import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface WizardPrefill {
    device_id?: string
    date?:      string
    start?:     string
}

export const useWizardStore = defineStore('wizard', () => {
    const open      = ref(false)
    const prefill   = ref<WizardPrefill>({})
    // Bumped after a successful submit so listeners (Reservations page) can reload.
    const changeTick = ref(0)

    const openWizard = (data: WizardPrefill = {}) => {
        prefill.value = data
        open.value = true
    }

    const closeWizard = () => {
        open.value = false
        prefill.value = {}
    }

    const notifyChanged = () => changeTick.value++

    return { open, prefill, changeTick, openWizard, closeWizard, notifyChanged }
})
